import { theme as baseTheme } from '../aidu/index.js';
import { colors } from '../reisen/colors.js';
export const theme = {
  ...baseTheme,
  colors
};